function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Skeleton, Form, Input, Button, Radio, Select, Collapse, Alert, Tabs } from 'antd';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import axios from 'axios';
import ProfileImageUploader from "../ProfileImageUploader";
import Common from "../includes/Common";
import { PencilFill } from 'react-bootstrap-icons';
import ResumeUploader from "./ResumeUploader";
import { PersonLinesFill, Book } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var Option = Select.Option;
var Panel = Collapse.Panel;
var TabPane = Tabs.TabPane;
var UserProfileUpdate = function UserProfileUpdate() {
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _Form$useForm3 = Form.useForm(),
    _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
    contactform = _Form$useForm4[0];
  var _Form$useForm5 = Form.useForm(),
    _Form$useForm6 = _slicedToArray(_Form$useForm5, 1),
    statusform = _Form$useForm6[0];
  var _Form$useForm7 = Form.useForm(),
    _Form$useForm8 = _slicedToArray(_Form$useForm7, 1),
    jobProfilForm = _Form$useForm8[0];
  var _Form$useForm9 = Form.useForm(),
    _Form$useForm10 = _slicedToArray(_Form$useForm9, 1),
    jobForm = _Form$useForm10[0];
  var _Form$useForm11 = Form.useForm(),
    _Form$useForm12 = _slicedToArray(_Form$useForm11, 1),
    employerForm = _Form$useForm12[0];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    dataChanged = _useState2[0],
    setDataChanged = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormError = _useState4[0],
    setIsFormError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isUserFound = _useState6[0],
    setIsUserFound = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isFormLoading = _useState10[0],
    setIsFormLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSuccessMessage = _useState12[0],
    setIsSuccessMessage = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    successMessage = _useState14[0],
    setSuccessMessage = _useState14[1];
  var _useState15 = useState({
      irstname: '',
      lastname: '',
      email: '',
      employer: '',
      jobname: '',
      jobprofil: '',
      employed: '0',
      jobdomainid: ''
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    user = _useState16[0],
    setUser = _useState16[1];
  var handleSubmit = function handleSubmit(field, value, errorId, successId, loadId) {
    var field2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var value2 = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    setIsFormLoading(true);
    setIsFormError(false);
    setIsSuccessMessage(false);
    document.getElementById(loadId).style.display = "inline";
    var formData = new FormData();
    formData.append(field, value);
    if (field2 != null) {
      formData.append(field2, value2);
    }
    axios.post(Common.baseApiUrl + 'updateuser/' + Common.currentUser.id.toString(), formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        setIsSuccessMessage(true);
        setIsFormError(false);
        setUser(response.data.user);
        setSuccessMessage(response.data.message);
        document.getElementById(successId).style.display = "block";
      } else {
        setIsFormError(true);
        setIsSuccessMessage(false);
        setErrorMessage(response.data.message);
        document.getElementById(errorId).style.display = "block";
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setIsFormError(true);
      setIsSuccessMessage(false);
      setErrorMessage('Une erreur est survenue');
      document.getElementById(errorId).style.display = "block";
    });
  };
  var onPersFinish = function onPersFinish(values) {
    handleSubmit('firstname', values.firstname, 'persalert', 'perssuccess', 'persload', 'lastname', values.lastname);
  };
  var onEmailFinish = function onEmailFinish(values) {
    handleSubmit('email', values.email, 'emailalert', 'emailsuccess', 'emailload');
  };
  var onStatusFinish = function onStatusFinish(values) {
    handleSubmit('employed', values.employed, 'statusalert', 'statussuccess', 'statusload');
  };
  var onDomainFinish = function onDomainFinish(values) {
    handleSubmit('jobdomainid', values.jobdomainid, 'domainalert', 'domainsuccess', 'domainload');
  };
  var onJobFinish = function onJobFinish(values) {
    handleSubmit('jobname', values.jobname, 'jobalert', 'jobsuccess', 'jobload');
  };
  var onEmpFinish = function onEmpFinish(values) {
    handleSubmit('employer', values.employer, 'empalert', 'empsuccess', 'empload');
  };
  var onProfilFinish = function onProfilFinish(values) {
    handleSubmit('jobprofil', values.jobprofil, 'jpalert', 'jpsuccess', 'jpload');
  };
  var _useState17 = useState({
      firstname: '',
      lastname: '',
      email: '',
      employer: '',
      jobname: '',
      jobprofil: '',
      employed: '0',
      jobdomainid: ''
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    initialVals = _useState18[0],
    setInitialVals = _useState18[1];
  var resumeAddHandler = function resumeAddHandler() {
    setDataChanged(true);
  };
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getuser/' + Common.currentUser.id.toString()).then(function (response) {
      var data = response['data'];
      if (data.status == '200') {
        setIsUserFound(true);
        setUser(data.user);
        form.setFieldsValue({
          firstname: data.user.firstname,
          lastname: data.user.lastname
        });
        contactform.setFieldsValue({
          email: data.user.email
        });
        statusform.setFieldsValue({
          employed: data.user.employed
        });
        jobForm.setFieldsValue({
          jobname: data.user.jobname
        });
        employerForm.setFieldsValue({
          employer: data.user.employer
        });
        jobProfilForm.setFieldsValue({
          jobprofil: data.user.jobprofil
        });
      }
    });
  }, [isUserFound, dataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isUserFound ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 8,
            sm: 9,
            children: /*#__PURE__*/_jsx(Tabs, {
              defaultActiveKey: "1",
              children: /*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PersonLinesFill, {
                    size: 22
                  }), " PARAMETRES PROFIL"]
                }),
                children: /*#__PURE__*/_jsxs(Collapse, {
                  style: {
                    backgroundColor: '#FFFFFF'
                  },
                  bordered: true,
                  accordion: true,
                  expandIconPosition: "right",
                  defaultActiveKey: ['1'],
                  expandIcon: function expandIcon(_ref) {
                    var isActive = _ref.isActive;
                    return /*#__PURE__*/_jsx(PencilFill, {
                      rotate: isActive ? 90 : 0
                    });
                  },
                  children: [/*#__PURE__*/_jsx(Panel, {
                    header: "INFORMATIONS PERSONNELLES",
                    children: /*#__PURE__*/_jsx("div", {
                      className: "single-edit-form-box",
                      children: /*#__PURE__*/_jsxs(Form, {
                        name: "perspdateform",
                        initialValues: initialVals,
                        size: "small",
                        onFinish: onPersFinish,
                        autoComplete: "off",
                        className: "uform",
                        form: form,
                        children: [/*#__PURE__*/_jsx("span", {
                          className: "highlight-comp",
                          children: "#Perso"
                        }), /*#__PURE__*/_jsx(Form.Item, {
                          label: "Votre pr\xE9nom",
                          name: "firstname",
                          rules: [{
                            required: true,
                            message: 'Veuillez entrer votre prénom'
                          }],
                          children: /*#__PURE__*/_jsx(Input, {
                            id: "uname"
                          })
                        }), /*#__PURE__*/_jsx(Form.Item, {
                          label: "Votre nom",
                          name: "lastname",
                          rules: [{
                            required: true,
                            message: 'Veuillez entrer votre nom'
                          }],
                          children: /*#__PURE__*/_jsx(Input, {
                            id: "name"
                          })
                        }), /*#__PURE__*/_jsxs(Form.Item, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            id: "perssendbtn",
                            type: "primary",
                            size: "small",
                            htmlType: "submit",
                            children: "Sauvegarder"
                          }), isFormLoading ? /*#__PURE__*/_jsx("div", {
                            id: "persload",
                            style: {
                              display: 'none'
                            },
                            children: /*#__PURE__*/_jsx(Spinner, {
                              animation: "grow",
                              variant: "warning"
                            })
                          }) : /*#__PURE__*/_jsx("span", {})]
                        }), isFormError ? /*#__PURE__*/_jsxs("div", {
                          id: "persalert",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: errorMessage,
                            type: "error",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {}), isSuccessMessage ? /*#__PURE__*/_jsxs("div", {
                          id: "perssuccess",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: successMessage,
                            type: "success",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {})]
                      })
                    })
                  }, "1"), /*#__PURE__*/_jsx(Panel, {
                    header: "ADRESSE E-MAIL",
                    children: /*#__PURE__*/_jsx("div", {
                      className: "single-edit-form-box",
                      children: /*#__PURE__*/_jsxs(Form, {
                        name: "emaildataform",
                        initialValues: initialVals,
                        size: "small",
                        onFinish: onEmailFinish,
                        autoComplete: "off",
                        className: "uform",
                        form: contactform,
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          label: "E-mail",
                          name: "email",
                          rules: [{
                            required: false,
                            message: 'Veuillez entrer une adresse e-mail  valide'
                          }],
                          children: /*#__PURE__*/_jsx(Input, {
                            id: "email"
                          })
                        }), /*#__PURE__*/_jsxs(Form.Item, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            id: "emailsendbtn",
                            type: "primary",
                            size: "small",
                            htmlType: "submit",
                            children: "Sauvegarder"
                          }), isFormLoading ? /*#__PURE__*/_jsx("div", {
                            id: "emailload",
                            style: {
                              display: 'none'
                            },
                            children: /*#__PURE__*/_jsx(Spinner, {
                              animation: "grow",
                              variant: "warning"
                            })
                          }) : /*#__PURE__*/_jsx("span", {})]
                        }), isFormError ? /*#__PURE__*/_jsxs("div", {
                          id: "emailalert",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: errorMessage,
                            type: "error",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {}), isSuccessMessage ? /*#__PURE__*/_jsxs("div", {
                          id: "emailsuccess",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: successMessage,
                            type: "success",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {})]
                      })
                    })
                  }, "2"), /*#__PURE__*/_jsx(Panel, {
                    header: "STATUS - " + (user.employed == 0 ? "CHOMEUR" : "EMPLOYE(E)"),
                    children: /*#__PURE__*/_jsx("div", {
                      className: "single-edit-form-box",
                      children: /*#__PURE__*/_jsxs(Form, {
                        name: "statusdataform",
                        initialValues: initialVals,
                        size: "small",
                        onFinish: onStatusFinish,
                        autoComplete: "off",
                        className: "uform",
                        form: statusform,
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          label: "Status",
                          name: "employed",
                          children: /*#__PURE__*/_jsxs(Radio.Group, {
                            buttonStyle: "solid",
                            children: [/*#__PURE__*/_jsx(Radio.Button, {
                              value: 0,
                              children: "Au chomage"
                            }, 0), /*#__PURE__*/_jsx(Radio.Button, {
                              value: 1,
                              children: "En service"
                            }, 1)]
                          })
                        }), /*#__PURE__*/_jsxs(Form.Item, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            id: "statussendbtn",
                            type: "primary",
                            size: "small",
                            htmlType: "submit",
                            children: "Sauvegarder"
                          }), isFormLoading ? /*#__PURE__*/_jsx("span", {
                            id: "statusload",
                            style: {
                              display: 'none'
                            },
                            children: /*#__PURE__*/_jsx(Spinner, {
                              animation: "grow",
                              variant: "warning"
                            })
                          }) : /*#__PURE__*/_jsx("span", {})]
                        }), isFormError ? /*#__PURE__*/_jsxs("div", {
                          id: "statuslalert",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: errorMessage,
                            type: "error",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {}), isSuccessMessage ? /*#__PURE__*/_jsxs("div", {
                          id: "statussuccess",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: successMessage,
                            type: "success",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {})]
                      })
                    })
                  }, "3"), /*#__PURE__*/_jsx(Panel, {
                    header: "DOMAINE",
                    children: /*#__PURE__*/_jsx("div", {
                      className: "single-edit-form-box",
                      children: /*#__PURE__*/_jsxs(Form, {
                        name: "domaindataform",
                        initialValues: initialVals,
                        size: "small",
                        onFinish: onDomainFinish,
                        autoComplete: "off",
                        className: "uform",
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          label: "Domaine de competence",
                          name: "jobdomainid",
                          children: /*#__PURE__*/_jsxs(Select, {
                            id: "jobdomain",
                            showSearch: true,
                            style: {
                              width: 200
                            },
                            placeholder: "Choisir",
                            optionFilterProp: "children",
                            filterOption: function filterOption(input, option) {
                              return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            },
                            filterSort: function filterSort(optionA, optionB) {
                              return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
                            },
                            children: [/*#__PURE__*/_jsx(Option, {
                              value: "1",
                              children: "Informatique"
                            }), /*#__PURE__*/_jsx(Option, {
                              value: "2",
                              children: "Finances"
                            }), /*#__PURE__*/_jsx(Option, {
                              value: "3",
                              children: "Hotelerie"
                            }), /*#__PURE__*/_jsx(Option, {
                              value: "4",
                              children: "Medecine"
                            }), /*#__PURE__*/_jsx(Option, {
                              value: "5",
                              children: "Marketing"
                            }), /*#__PURE__*/_jsx(Option, {
                              value: "6",
                              children: "Communication"
                            })]
                          })
                        }), /*#__PURE__*/_jsxs(Form.Item, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            id: "domainsendbtn",
                            type: "primary",
                            size: "small",
                            htmlType: "submit",
                            children: "Sauvegarder"
                          }), isFormLoading ? /*#__PURE__*/_jsx("span", {
                            id: "domainload",
                            style: {
                              display: 'none'
                            },
                            children: /*#__PURE__*/_jsx(Spinner, {
                              animation: "grow",
                              variant: "warning"
                            })
                          }) : /*#__PURE__*/_jsx("span", {})]
                        }), isFormError ? /*#__PURE__*/_jsxs("div", {
                          id: "domainalert",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: errorMessage,
                            type: "error",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {}), isSuccessMessage ? /*#__PURE__*/_jsxs("div", {
                          id: "domainsuccess",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: successMessage,
                            type: "success",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {})]
                      })
                    })
                  }, "4"), /*#__PURE__*/_jsx(Panel, {
                    header: "EMPLOI ACTUEL",
                    children: /*#__PURE__*/_jsx("div", {
                      className: "single-edit-form-box",
                      children: /*#__PURE__*/_jsxs(Form, {
                        name: "jobdataform",
                        initialValues: initialVals,
                        size: "small",
                        onFinish: onJobFinish,
                        autoComplete: "off",
                        className: "uform",
                        form: jobForm,
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          label: "Emploi actuel",
                          name: "jobname",
                          children: /*#__PURE__*/_jsx(Input, {
                            id: "jobname"
                          })
                        }), /*#__PURE__*/_jsxs(Form.Item, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            id: "jobsendbtn",
                            type: "primary",
                            size: "small",
                            htmlType: "submit",
                            children: "Sauvegarder"
                          }), isFormLoading ? /*#__PURE__*/_jsx("span", {
                            id: "jobload",
                            style: {
                              display: 'none'
                            },
                            children: /*#__PURE__*/_jsx(Spinner, {
                              animation: "grow",
                              variant: "warning"
                            })
                          }) : /*#__PURE__*/_jsx("span", {})]
                        }), isFormError ? /*#__PURE__*/_jsxs("div", {
                          id: "joblalert",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: errorMessage,
                            type: "error",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {}), isSuccessMessage ? /*#__PURE__*/_jsxs("div", {
                          id: "jobsuccess",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: successMessage,
                            type: "success",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {})]
                      })
                    })
                  }, "5"), /*#__PURE__*/_jsx(Panel, {
                    header: "EMPLOYEUR",
                    children: /*#__PURE__*/_jsx("div", {
                      className: "single-edit-form-box",
                      children: /*#__PURE__*/_jsxs(Form, {
                        name: "empdataform",
                        size: "small",
                        onFinish: onEmpFinish,
                        autoComplete: "off",
                        className: "uform",
                        form: employerForm,
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          label: "Employeur",
                          name: "employer",
                          children: /*#__PURE__*/_jsx(Input, {
                            id: "employer"
                          })
                        }), /*#__PURE__*/_jsxs(Form.Item, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            id: "empsendbtn",
                            type: "primary",
                            size: "small",
                            htmlType: "submit",
                            children: "Sauvegarder"
                          }), isFormLoading ? /*#__PURE__*/_jsx("span", {
                            id: "empload",
                            style: {
                              display: 'none'
                            },
                            children: /*#__PURE__*/_jsx(Spinner, {
                              animation: "grow",
                              variant: "warning"
                            })
                          }) : /*#__PURE__*/_jsx("span", {})]
                        }), isFormError ? /*#__PURE__*/_jsxs("div", {
                          id: "empalert",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: errorMessage,
                            type: "error",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {}), isSuccessMessage ? /*#__PURE__*/_jsxs("div", {
                          id: "empsuccess",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: successMessage,
                            type: "success",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {})]
                      })
                    })
                  }, "6"), /*#__PURE__*/_jsx(Panel, {
                    header: "PROFIL PROFESSIONNEL",
                    children: /*#__PURE__*/_jsx("div", {
                      className: "single-edit-form-box",
                      children: /*#__PURE__*/_jsxs(Form, {
                        name: "jpdataform",
                        size: "small",
                        onFinish: onProfilFinish,
                        autoComplete: "off",
                        className: "uform",
                        form: jobProfilForm,
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          label: "Profil professionnel",
                          name: "jobprofil",
                          children: /*#__PURE__*/_jsx(TextArea, {
                            id: "jobprofil",
                            placeholder: "Decrivez ici vos competences",
                            autoSize: {
                              minRows: 1,
                              maxRows: 6
                            }
                          })
                        }), /*#__PURE__*/_jsxs(Form.Item, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            id: "jpsendbtn",
                            type: "primary",
                            size: "small",
                            htmlType: "submit",
                            children: "Sauvegarder"
                          }), isFormLoading ? /*#__PURE__*/_jsx("span", {
                            id: "jpload",
                            style: {
                              display: 'none'
                            },
                            children: /*#__PURE__*/_jsx(Spinner, {
                              animation: "grow",
                              variant: "warning"
                            })
                          }) : /*#__PURE__*/_jsx("span", {})]
                        }), isFormError ? /*#__PURE__*/_jsxs("div", {
                          id: "jpalert",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: errorMessage,
                            type: "error",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {}), isSuccessMessage ? /*#__PURE__*/_jsxs("div", {
                          id: "jpsuccess",
                          style: {
                            display: 'none'
                          },
                          children: [" ", /*#__PURE__*/_jsx(Alert, {
                            banner: true,
                            closable: true,
                            style: {
                              marging: '5px 0px',
                              fontSize: '14px'
                            },
                            message: successMessage,
                            type: "success",
                            showIcon: true
                          })]
                        }) : /*#__PURE__*/_jsx("span", {})]
                      })
                    })
                  }, "7")]
                })
              }, "2")
            })
          })
        })
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 4,
            sm: 3,
            children: /*#__PURE__*/_jsx(Skeleton, {
              active: true,
              avatar: true,
              paragraph: {
                rows: 3
              }
            })
          })
        })
      })
    })
  });
};
export default UserProfileUpdate;